import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createElement, Component } from 'react';
import InputField from '../Input/InputField';
import { padNumber, getTabbableSiblings } from '../utils';
var MIN_VALUE = -Infinity;
var MAX_VALUE = Infinity;
var ACCEPTED_KEYS = ['Backspace', 'Delete', 'Tab', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', '-', '.'];

function getPadStringSize(pad) {
  var str = '';

  for (var i = 0; i < pad; i++) {
    str += '0';
  }

  return str;
}

function isNotAcceptedNumberKey(event) {
  return !event.metaKey && event.key !== 'v' && isNaN(parseInt(event.key, 10)) && ACCEPTED_KEYS.indexOf(event.key) === -1;
}

var NumberField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NumberField, _Component);

  function NumberField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "firstTouch", true);

    _defineProperty(_assertThisInitialized(_this), "getParsedValues", function (value) {
      return {
        value: Number.parseFloat(value),
        minValue: Number.parseFloat(_this.props.min),
        maxValue: Number.parseFloat(_this.props.max)
      };
    });

    _defineProperty(_assertThisInitialized(_this), "clampValue", function (valueToCheck) {
      var _this$getParsedValues = _this.getParsedValues(valueToCheck),
          value = _this$getParsedValues.value,
          minValue = _this$getParsedValues.minValue;

      return isNaN(value) ? minValue === MIN_VALUE ? 0 : minValue : value;
    });

    _defineProperty(_assertThisInitialized(_this), "isValueValid", function (valueToCheck) {
      var _this$getParsedValues2 = _this.getParsedValues(valueToCheck),
          value = _this$getParsedValues2.value,
          minValue = _this$getParsedValues2.minValue,
          maxValue = _this$getParsedValues2.maxValue;

      return value >= minValue && value <= maxValue;
    });

    _defineProperty(_assertThisInitialized(_this), "changeIfValid", function (value) {
      if (_this.isValueValid(value)) {
        _this.props.onChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var _this$getParsedValues3 = _this.getParsedValues(event.target.value),
          value = _this$getParsedValues3.value,
          minValue = _this$getParsedValues3.minValue,
          maxValue = _this$getParsedValues3.maxValue;

      if (value < minValue) {
        _this.props.onChange(minValue);
      } else if (value > maxValue) {
        _this.props.onChange(maxValue);
      } else if (isNaN(event.target.value)) {
        _this.props.onChange(_this.clampValue(value));
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.firstTouch = true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props = _this.props,
          pad = _this$props.pad,
          step = _this$props.step;

      var _this$getParsedValues4 = _this.getParsedValues(event.target.value),
          value = _this$getParsedValues4.value,
          minValue = _this$getParsedValues4.minValue,
          maxValue = _this$getParsedValues4.maxValue;

      if (isNotAcceptedNumberKey(event) || pad && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
      }

      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        var increment = (event.key === 'ArrowUp' ? 1 : -1) * step;

        var nextValue = _this.clampValue(value + increment);

        var parsedValue = Number.parseFloat(event.target.value.indexOf('.') > -1 ? nextValue.toFixed(2) : nextValue);

        if (_this.isValueValid(parsedValue)) {
          _this.props.onChange(parsedValue);
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInput", function (event) {
      var _this$getParsedValues5 = _this.getParsedValues(event.target.value),
          maxValue = _this$getParsedValues5.maxValue;

      if (_this.props.pad) {
        var targetValue = event.target.value === '' ? event.target.value : parseFloat(event.target.value);

        var nextValue = _this.clampValue(targetValue);

        if (nextValue !== '') {
          if (_this.props.pad) {
            var paddedValue = parseFloat("" + _this.props.value + targetValue);

            if (!_this.firstTouch && !isNaN(targetValue) && _this.isValueValid(paddedValue)) {
              nextValue = paddedValue;
            }

            _this.firstTouch = false;
          }

          if (_this.props.moveFocusOnMax && nextValue / maxValue > 0.1) {
            var _getTabbableSiblings = getTabbableSiblings(event.target),
                next = _getTabbableSiblings.next;

            if (next) {
              setTimeout(function () {
                return next.focus();
              });
            }
          }

          _this.changeIfValid(nextValue);
        } else {
          _this.props.onChange('');
        }
      } else {
        _this.props.onChange(event.target.value);
      }
    });

    return _this;
  }

  var _proto = NumberField.prototype;

  _proto.getAutoWidthValue = function getAutoWidthValue(value) {
    var _this$props2 = this.props,
        autoWidth = _this$props2.autoWidth,
        pad = _this$props2.pad,
        placeholder = _this$props2.placeholder;
    var isValueEmpty = value === '';
    return autoWidth || (pad && isValueEmpty ? getPadStringSize(pad) : isValueEmpty && placeholder !== undefined ? placeholder : value);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        autoWidth = _this$props3.autoWidth,
        as = _this$props3.as,
        highlightOnInteraction = _this$props3.highlightOnInteraction,
        min = _this$props3.min,
        max = _this$props3.max,
        moveFocusOnMax = _this$props3.moveFocusOnMax,
        onChange = _this$props3.onChange,
        onBlur = _this$props3.onBlur,
        onInput = _this$props3.onInput,
        onKeyDown = _this$props3.onKeyDown,
        pad = _this$props3.pad,
        value = _this$props3.value,
        restProps = _objectWithoutPropertiesLoose(_this$props3, ["autoWidth", "as", "highlightOnInteraction", "min", "max", "moveFocusOnMax", "onChange", "onBlur", "onInput", "onKeyDown", "pad", "value"]);

    var parsed = this.getParsedValues(value);
    var numberValue = value === null ? '' : value;

    if (pad && numberValue !== '') {
      numberValue = padNumber(numberValue, pad);
    }

    if (parsed.min !== MIN_VALUE) {
      restProps.min = min;
    }

    if (parsed.max !== MAX_VALUE) {
      restProps.max = max;
    }

    if (autoWidth !== false) {
      restProps.autoWidth = this.getAutoWidthValue(numberValue);

      if (restProps.autoWidth === undefined) {
        restProps.autoWidth = true;
      }
    }

    return /*#__PURE__*/createElement(as, _objectSpread(_objectSpread({}, restProps), {}, {
      textOverflow: undefined,
      autoComplete: 'off',
      value: numberValue,
      highlightOnInteraction: highlightOnInteraction || pad,
      onBlur: this.handleBlur,
      onInput: this.handleInput,
      onKeyDown: this.handleKeyDown
    }));
  };

  return NumberField;
}(Component);

_defineProperty(NumberField, "defaultProps", {
  as: InputField,
  min: MIN_VALUE,
  max: MAX_VALUE,
  step: 1,
  moveFocusOnMax: false
});

export default NumberField;